import { Icon, IconProps } from '@chakra-ui/react'

export default function ListBulletsIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M5.99915 4.7905H13.3355"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3355 8.49753H7.33301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66693 12.2085H13.3355"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.9979 4.45703C2.81373 4.45703 2.66443 4.60633 2.66443 4.7905C2.66443 4.97468 2.81373 5.12398 2.9979 5.12398C3.18207 5.12398 3.33137 4.97468 3.33137 4.7905C3.33137 4.60633 3.18207 4.45703 2.9979 4.45703"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33176 8.16406C4.14759 8.16406 3.99829 8.31336 3.99829 8.49753C3.99829 8.68171 4.14759 8.83101 4.33176 8.83101C4.51593 8.83101 4.66524 8.68171 4.66524 8.49753C4.66524 8.31336 4.51593 8.16406 4.33176 8.16406"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66569 11.875C5.48151 11.875 5.33221 12.0243 5.33221 12.2085C5.33221 12.3926 5.48151 12.5419 5.66569 12.5419C5.84986 12.5419 5.99916 12.3926 5.99916 12.2085C5.99916 12.0243 5.84986 11.875 5.66569 11.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
